import { useEffect, useState } from "react";

export const torontoNow = () => new Date().toLocaleString("sv-SE", { timeZone: "America/Toronto" }).replace(" ", "T").slice(0, 16);
export const inWindow = (s, now = torontoNow()) => (!s.start_at || s.start_at <= now) && (!s.end_at || now < s.end_at);

// Cycles through slides, each shown for its own `duration` seconds; holds while paused.
export function useSlideRotation(slides, paused = false) {
  const [idx, setIdx] = useState(0);
  const n = slides.length;
  useEffect(() => { if (idx >= n) setIdx(0); }, [n, idx]);
  const cur = n ? slides[Math.min(idx, n - 1)] : null;
  const ms = Math.max(2, Math.min(60, Number(cur?.duration) || 6)) * 1000;
  useEffect(() => {
    if (n <= 1 || paused) return;
    const t = setTimeout(() => setIdx((i) => (i + 1) % n), ms);
    return () => clearTimeout(t);
  }, [idx, n, ms, paused]);
  return [Math.min(idx, Math.max(0, n - 1)), setIdx];
}
